var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaymentRow',{attrs:{"net-amount":_vm.netAmountInPLN,"tax-value":_vm.data.payment.vatPercentage,"start-with-gross":_vm.field.gross},on:{"update":function($event){return _vm.updateValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }